var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("circle", {
    id: "svg_1",
    strokeWidth: 3,
    stroke: "#04A89F",
    fill: "white",
    r: 10.5,
    cy: 12,
    cx: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#05A9A0",
    d: "m13.2656,15.0269l-2.5019,0l-0.523,-10.01811l3.5479,0l-0.523,10.01811zm-3.0659,3.5068c0,-0.6426 0.1743,-1.0938 0.523,-1.3535c0.3554,-0.2598 0.7827,-0.3897 1.2817,-0.3897c0.4853,0 0.9023,0.1299 1.251,0.3897c0.3554,0.2597 0.5332,0.7109 0.5332,1.3535c0,0.6152 -0.1778,1.0596 -0.5332,1.333c-0.3487,0.2734 -0.7657,0.4102 -1.251,0.4102c-0.499,0 -0.9263,-0.1368 -1.2817,-0.4102c-0.3487,-0.2734 -0.523,-0.7178 -0.523,-1.333z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/Exclamation.551cb2b9e297ca78c802d4543f7a3f62.svg";
export { ForwardRef as ReactComponent };